export const PATIENT_DATA_URL = 'patientData';
